import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { BackNativeService } from '../../../shared/service/comunicator-native/back-native/back-native';
import { FormBuilder, FormControl } from '@angular/forms';
import { FormValidations } from '../../../shared/form-validation/form-validation';
import { Title } from '@angular/platform-browser';
import { DefaultPageComponent } from '../../../shared/page/default-page.component';
import { JourneyService } from '../../../shared/service/journey/journey.service';
import { ReturnNativeService } from '../../../shared/service/comunicator-native/return-native/return-native';
import { AnalycticsNativeService } from '../../../shared/service/comunicator-native/analytics-native/analyctics-native';
import { ProfileDataService } from '../../service/profile-data.service';
import { AnalyticsPageService } from '../../../shared/service/analytics/analytics-page.service';
import { AnalyticsPageModel } from '../../../shared/model/analyticsPage';
import { TrackTypes } from '../../../shared/service/journey/tracks/model/track-types';
import { AnalyticsGA4PagesModel } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models';
import { AnalyticsGA4PageService } from '../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service';

@Component({
  selector: 'app-name',
  templateUrl: './name.component.html',
  styleUrls: ['./name.component.scss'],
})
export class NameComponent extends DefaultPageComponent implements OnInit {

  name = '';
  idComponentName = 'UserName';
  placeholder = 'Nome';
  error = false;
  buttonEnable = false;
  textError = '';
  minLengthErrorText = 'Esse nome está incompleto';
  invalidErrorText = 'Nome inválido';
  invalidErrorRepeated = 'Por favor, não utilize sequências de letras maior (ex: AAA, BBB)';
  maxLengthErrorText = 'Limite de caracteres alcançado';
  cacheNative: any;
  idLabel = 'nameDoc';
  label = 'nome';
  startStage = '';
  endStage = '';

  nameForm = this.formBuilder.group({
    docName: this.formBuilder.control('', [FormValidations.checkShortNameUser, FormValidations.validationsNameDoc])
  });

  headerId = 'page-name';
  titlePage = 'Dados de contato';
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;


  constructor(
    public router: NavController,
    private profileDataService: ProfileDataService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private formBuilder: FormBuilder,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    private analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getTrack();
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
  }

/* istanbul ignore next */
  get docName() { return this.nameForm.get('docName'); }

  /* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest('nome', 'name', 'profileData');
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = 'profile';

    this.startStage = (track.getIndexPage(this.headerId, path)).toString();
    this.endStage = (track.getTotalPage(path)).toString();
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  backPage() {
    this.analyticsEventClique();
    if (this.journeyService.journey ===  TrackTypes.BASIC_PROFILE_V2
      || this.journeyService.journey ===  TrackTypes.UPDATE_PROFILE) {
      this.router.navigateForward(['data', 'client-data']);
    } else {
      this.back();
    }
  }

  clickNext() {
    this.profileDataService.setDocumentNameData(this.name.trim());
    this.nextPage();
  }

  getPageId(): string {
    return this.headerId;
  }

  errorMsg() {
    const control = this.nameForm.get('docName') as FormControl;
    this.error = control.errors !== null;

    this.error ? this.buttonEnable = false : this.buttonEnable = true;

    if (control.errors !== null && control.errors.hasOwnProperty('checkShortNameMin')) {
      this.textError = this.invalidErrorText;
    }

    if (control.errors !== null && control.errors.hasOwnProperty('checkShortNameMax')) {
      this.textError = this.maxLengthErrorText;
    }

    if (control.errors !== null && control.errors.hasOwnProperty('nameSpace')) {
      this.textError = this.invalidErrorText;
    }

    if (control.errors !== null && control.errors.hasOwnProperty('repeated')) {
      this.textError = this.invalidErrorRepeated;
    }
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data?.profileData?.name?.length > 1) {
      this.name = this.journeyService.registratioJourney.data?.profileData?.name;
      this.nameForm.controls.docName.setValue(this.journeyService.registratioJourney.data?.profileData?.name);
      this.errorMsg();
    }
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  analyticsData() {
    // tslint:disable-next-line:variable-name
    const it_pagename = this.analyticsPage?.name;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  analyticsEventClique() {
    // tslint:disable-next-line:variable-name
    const it_eventcategory = 'Clique';
    // tslint:disable-next-line:variable-name
    const it_complementary = {
      it_eventaction: this.analyticsPage?.action,
      it_eventlabel: this.analyticsPage?.back,
      it_pagename: this.analyticsPage?.name
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(it_eventcategory, it_complementary);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathNomeEscolhido,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl)
  }

}